export const SearchIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    className="nav-search-icon"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.54785 0.0185242C3.38846 0.0185242 0.0166016 3.39038 0.0166016 7.54977C0.0166016 11.7092 3.38846 15.081 7.54785 15.081C9.44761 15.081 11.1831 14.3776 12.508 13.2171L17.2724 17.9815L17.9795 17.2744L13.2151 12.5099C14.3757 11.185 15.0791 9.44953 15.0791 7.54977C15.0791 3.39038 11.7072 0.0185242 7.54785 0.0185242ZM7.54785 1.01852C11.155 1.01852 14.0791 3.94266 14.0791 7.54977C14.0791 11.1569 11.155 14.081 7.54785 14.081C3.94074 14.081 1.0166 11.1569 1.0166 7.54977C1.0166 3.94266 3.94074 1.01852 7.54785 1.01852Z"
      fill="currentColor"
    />
  </svg>
)

export const SearchNotificationIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="31"
    viewBox="0 0 18 31"
    fill="none"
    className="nav-search-icon"
  >
    <circle cx="12.4971" cy="9" r="2.5" fill="#00BCE5" />
    <mask
      id="mask0_7310_23014"
      mask-type="alpha"
      maskUnits="userSpaceOnUse"
      x="-1"
      y="0"
      width="19"
      height="31"
    >
      <path
        d="M17.9971 30.5H-0.00292969V0.5H17.9971V30.5ZM12.4971 5.5C10.5641 5.5 8.99707 7.067 8.99707 9C8.99707 10.933 10.5641 12.5 12.4971 12.5C14.4301 12.5 15.9971 10.933 15.9971 9C15.9971 7.067 14.4301 5.5 12.4971 5.5Z"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask0_7310_23014)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.54834 6.51855C3.38895 6.51855 0.0170898 9.89041 0.0170898 14.0498C0.0170898 18.2092 3.38895 21.5811 7.54834 21.5811C9.44809 21.5811 11.1836 20.8777 12.5085 19.7171L17.2729 24.4815L17.98 23.7744L13.2156 19.01C14.3762 17.685 15.0796 15.9496 15.0796 14.0498C15.0796 9.89041 11.7077 6.51855 7.54834 6.51855ZM7.54834 7.51855C11.1554 7.51855 14.0796 10.4427 14.0796 14.0498C14.0796 17.6569 11.1554 20.5811 7.54834 20.5811C3.94123 20.5811 1.01709 17.6569 1.01709 14.0498C1.01709 10.4427 3.94123 7.51855 7.54834 7.51855Z"
        fill="currentColor"
      />
    </g>
  </svg>
)
